import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import I18n from 'i18n.js.erb'
import { compareStrings, isDefined, pluralize } from "../../utils/utils";

const TransferCertificatesModal = ({
  showModal,
  toUserBlockchainKey,
  setToUserBlockchainKey,
  gradingCertificatesNumbers,
  handleConfirm,
  handleCloseModal,
  products,
  errorMessage
}) => {

  const gradingLabels = products.map(product => {
    return product.current_grading.extended_serial_number;
  })


  return <Modal id="transfer-certificates-modal" show={showModal} onHide={handleCloseModal} animation={false} size="lg">
    <Modal.Header closeButton>
      <Modal.Title className="w-100 text-center mt-1">
        {pluralize(gradingCertificatesNumbers.length, 'myCollectionEditPage.transferCertificate')}
      </Modal.Title>
    </Modal.Header>

    <Modal.Body>
      <p>
        {pluralize(gradingCertificatesNumbers.length, 'myCollectionEditPage.transferCertificatesNumber')}:&nbsp;
        {isDefined(gradingLabels) ? gradingLabels.join(', ') : ''}.
      </p>

      <p>
        {I18n.t('js.myCollectionEditPage.transferCertificatesText1')}
      </p>

      <p>
        {I18n.t('js.myCollectionEditPage.transferCertificatesText2')}
      </p>

      <div className="row">
        <div className="col-12">
          {pluralize(gradingCertificatesNumbers.length, 'myCollectionEditPage.transferCertificatesToUser')}
        </div>

        <div className="col-12">
          <input
            id="to_user_blockchain_key"
            type="text"
            value={toUserBlockchainKey ? toUserBlockchainKey : ''}
            className="form-control my-3"
            onChange={(e) => setToUserBlockchainKey(e.target.value)}
          />
        </div>
      </div>

      <p className="color-red">{errorMessage}</p>
    </Modal.Body>

    <Modal.Footer>
      <button
        type="button"
        className="btn-standard-outline br-20px pr-2 pl-2 w-120px btn-standard-outline-resized text-weight-500"
        onClick={handleCloseModal}
      >
        {I18n.t('js.common.button.cancel').toUpperCase()}
      </button>

      <button
        type="button"
        className="btn-standard bg-aig-gradient text-light br-20px px-3 btn-standard-resized pt-6px-imp h-35px text-weight-500"
        disabled={!isDefined(toUserBlockchainKey)}
        onClick={() => handleConfirm(toUserBlockchainKey, products)}
      >
        {I18n.t('js.common.button.transfer').toUpperCase()}
      </button>
    </Modal.Footer>
  </Modal>
};

export default TransferCertificatesModal;